import { Stack, Typography } from '@prenuvo/halo';

import { PoetryMetadata, Sku } from '@/api';
import { formatTimestampToDate } from '@/shared/util';

import { getSkuPackage } from '../../../../../util';
import { SERVICE_INFO_ORDER } from '../../../header.constant';
import { getServiceInfoNameList } from '../../../header.util';

interface DocumentsByStudyHeaderProps {
  poetryMetadata?: null | PoetryMetadata;
  scanDate?: number;
  sku?: Sku;
  studyId?: string;
  timezone?: string;
}

export function DocumentsByStudyHeader({
  poetryMetadata,
  scanDate,
  sku,
  studyId,
  timezone,
}: DocumentsByStudyHeaderProps) {
  const imagingServices = (poetryMetadata?.servicesInfo ?? []).filter((service) =>
    SERVICE_INFO_ORDER.includes(service.code),
  );

  const SKU_PACKAGE =
    sku && sku === '900'
      ? `${getServiceInfoNameList(imagingServices).join(' • ')}`
      : getSkuPackage(Number(sku));

  return (
    <Stack className="border-b border-neutral-600 px-3 pt-2 pb-3" gap={6}>
      {sku && (
        <Typography
          translationKey="FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENTS.HEADER.SKU_PACKAGE"
          values={{ skuPackage: SKU_PACKAGE }}
          variant="paragraph-sm-bold"
        />
      )}

      {scanDate && (
        <Typography
          translationKey="FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENTS.HEADER.SCAN_DATE"
          values={{ value: formatTimestampToDate(scanDate, timezone) }}
          variant="paragraph-sm-bold"
        />
      )}

      {studyId && (
        <Typography
          translationKey="FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENTS.HEADER.STUDY_ID"
          values={{ value: studyId }}
          variant="paragraph-sm-bold"
        />
      )}
    </Stack>
  );
}
